<template>
    <div>
        <el-form :inline="true" :model="queryParams" size="small" style="text-align: left; margin-top: 5px">
            <el-form-item label="学校选择">
                <el-select v-model="queryParams.schoolId" placeholder="请选择学校" :clearable="!schoolLocked" filterable :disabled="schoolLocked" @change="getList">
                    <el-option
                            v-for="item in schoolList"
                            :key="item.schoolId"
                            :label="item.schoolName"
                            :value="item.schoolId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="活动名">
                <el-input v-model="queryParams.campaignName" placeholder="活动名" clearable @keyup.enter.native="getList" />
            </el-form-item>
            <el-form-item label="状态">
                <el-select v-model="queryParams.status" placeholder="全部" clearable>
                    <el-option label="草稿" value="0" />
                    <el-option label="进行中" value="1" />
                    <el-option label="停用" value="2" />
                    <el-option label="已结束" value="3" />
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" @click="getList">查询</el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
            </el-form-item>
        </el-form>

        <el-row :gutter="10" class="mb8">
            <el-col :span="1.5">
                <el-button type="primary" plain icon="el-icon-plus" size="mini" :disabled="!queryParams.schoolId" @click="openForm()">新增活动</el-button>
            </el-col>
        </el-row>

        <el-table :data="list" border style="width: 100%">
            <el-table-column label="活动名" prop="campaignName" align="center" min-width="140" :show-overflow-tooltip="true" />
            <el-table-column label="券模板" align="center" min-width="140" :show-overflow-tooltip="true">
                <template slot-scope="scope">{{ scope.row.couponName || scope.row.couponId }}</template>
            </el-table-column>
            <el-table-column label="时间" align="center" min-width="200">
                <template slot-scope="scope">{{ formatTime(scope.row.startTime) }} ~ {{ formatTime(scope.row.endTime) }}</template>
            </el-table-column>
            <el-table-column label="总量/已领" align="center" width="110">
                <template slot-scope="scope">
                    {{ scope.row.totalQuota == null ? '不限' : scope.row.totalQuota }} / {{ scope.row.claimedCount || 0 }}
                </template>
            </el-table-column>
            <el-table-column label="每人限额" prop="perUserLimit" align="center" width="90" />
            <el-table-column label="状态" align="center" width="100">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.displayStatus === '0'" size="small">草稿</el-tag>
                    <el-tag v-else-if="scope.row.displayStatus === '1'" size="small" type="success">进行中</el-tag>
                    <el-tag v-else-if="scope.row.displayStatus === '2'" size="small" type="info">停用</el-tag>
                    <el-tag v-else size="small" type="warning">已结束</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="280">
                <template slot-scope="scope">
                    <el-button size="mini" type="text" @click="openForm(scope.row)">编辑</el-button>
                    <el-button v-if="scope.row.status === '0' || scope.row.status === '2'" size="mini" type="text" @click="changeStatus(scope.row, '1')">发布</el-button>
                    <el-button v-if="scope.row.status !== '2'" size="mini" type="text" @click="changeStatus(scope.row, '2')">停用</el-button>
                    <el-button size="mini" type="text" @click="openRecords(scope.row)">领取记录</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
                style="margin-top: 16px; text-align: right"
                layout="total, prev, pager, next"
                :current-page="queryParams.pageNum"
                :page-size="queryParams.pageSize"
                :total="total"
                @current-change="handlePageChange">
        </el-pagination>

        <el-dialog :title="dialogTitle" :visible.sync="dialogOpen" width="560px" @close="resetForm">
            <el-form ref="campaignForm" :model="form" :rules="rules" label-width="110px" size="small">
                <el-form-item label="学校" prop="schoolId">
                    <el-select v-model="form.schoolId" placeholder="请选择学校" :disabled="!!form.id || schoolLocked" filterable @change="loadCoupons">
                        <el-option
                                v-for="item in schoolList"
                                :key="item.schoolId"
                                :label="item.schoolName"
                                :value="item.schoolId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="活动名" prop="campaignName">
                    <el-input v-model="form.campaignName" maxlength="40" :disabled="runningLocked" />
                </el-form-item>
                <el-form-item label="券模板" prop="couponId">
                    <el-select v-model="form.couponId" placeholder="本校已发布券" filterable :disabled="runningLocked">
                        <el-option
                                v-for="item in couponList"
                                :key="item.id"
                                :label="item.couponName + '（' + item.money + '元）'"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="活动时间" prop="timeRange">
                    <el-date-picker
                            v-model="form.timeRange"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始"
                            end-placeholder="结束"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :disabled="runningLocked">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="总量">
                    <el-input-number v-model="form.totalQuota" :min="-1" />
                    <div style="color:#909399;font-size:12px;">空或不填表示不限</div>
                </el-form-item>
                <el-form-item label="每人限额" prop="perUserLimit">
                    <el-input-number v-model="form.perUserLimit" :min="1" :precision="0" :disabled="runningLocked" />
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="dialogOpen = false">取 消</el-button>
                <el-button type="primary" :loading="submitLoading" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>

        <el-drawer :title="'领取记录 - ' + (recordCampaign.campaignName || '')" :visible.sync="recordOpen" size="480px">
            <el-table :data="recordList" border size="small">
                <el-table-column label="用户" align="center" min-width="120">
                    <template slot-scope="scope">{{ scope.row.jpNickName || scope.row.userId }}</template>
                </el-table-column>
                <el-table-column label="手机号" prop="jpPhone" align="center" width="120" />
                <el-table-column label="实例ID" prop="userCouponId" align="center" width="80" />
                <el-table-column label="时间" prop="createTime" align="center" min-width="150" />
            </el-table>
            <el-pagination
                    style="margin-top: 16px; text-align: right"
                    layout="total, prev, pager, next"
                    :current-page="recordQuery.pageNum"
                    :page-size="recordQuery.pageSize"
                    :total="recordTotal"
                    @current-change="handleRecordPage">
            </el-pagination>
        </el-drawer>
    </div>
</template>

<script>
import { isSchoolScoped, getBoundSchoolId, lockSchoolOptions } from '@/utils/schoolScope'
export default {
    name: 'CouponCampaign',
    computed: {
        schoolLocked() {
            return isSchoolScoped()
        },
        runningLocked() {
            return this.form.status === '1'
        }
    },
    data() {
        return {
            schoolList: [],
            couponList: [],
            list: [],
            total: 0,
            dialogOpen: false,
            dialogTitle: '新增活动',
            submitLoading: false,
            recordOpen: false,
            recordCampaign: {},
            recordList: [],
            recordTotal: 0,
            queryParams: {
                schoolId: null,
                campaignName: '',
                status: '',
                pageNum: 1,
                pageSize: 10
            },
            recordQuery: {
                campaignId: null,
                pageNum: 1,
                pageSize: 10
            },
            form: this.emptyForm(),
            rules: {
                schoolId: [{ required: true, message: '请选择学校', trigger: 'change' }],
                campaignName: [{ required: true, message: '请输入活动名', trigger: 'blur' }],
                couponId: [{ required: true, message: '请选择券模板', trigger: 'change' }],
                timeRange: [{ required: true, message: '请选择活动时间', trigger: 'change' }],
                perUserLimit: [{ required: true, message: '请输入每人限额', trigger: 'blur' }]
            }
        }
    },
    created() {
        this.getSchoolList()
    },
    methods: {
        emptyForm() {
            return {
                id: null,
                schoolId: null,
                campaignName: '',
                couponId: null,
                timeRange: [],
                startTime: null,
                endTime: null,
                totalQuota: undefined,
                perUserLimit: 1,
                status: '0'
            }
        },
        formatTime(value) {
            if (!value) {
                return '-'
            }
            return String(value).replace('T', ' ').substring(0, 16)
        },
        async getSchoolList() {
            const res = await this.$http.get('/school/AppGetCampusSchoolList')
            if (res.data.code === 200) {
                this.schoolList = lockSchoolOptions(res.data.data || [])
                if (isSchoolScoped() && getBoundSchoolId() != null) {
                    this.queryParams.schoolId = getBoundSchoolId()
                    this.getList()
                }
            }
        },
        async loadCoupons(schoolId) {
            const id = schoolId || this.form.schoolId || this.queryParams.schoolId
            if (!id) {
                this.couponList = []
                return
            }
            const res = await this.$http.get('/coupon/getPublishedList', { params: { schoolId: id } })
            if (res.data.code === 200) {
                this.couponList = res.data.data || []
            }
        },
        async getList() {
            const res = await this.$http.get('/admin/couponCampaign/list', { params: this.queryParams })
            if (res.data.code === 200) {
                const page = res.data.data || {}
                this.list = page.children || []
                this.total = page.total || 0
            } else {
                this.$message.error(res.data.msg || '查询失败')
            }
        },
        resetQuery() {
            this.queryParams.campaignName = ''
            this.queryParams.status = ''
            this.queryParams.pageNum = 1
            if (!this.schoolLocked) {
                this.queryParams.schoolId = null
                this.list = []
                this.total = 0
                return
            }
            this.getList()
        },
        handlePageChange(page) {
            this.queryParams.pageNum = page
            this.getList()
        },
        openForm(row) {
            if (row) {
                this.dialogTitle = '编辑活动'
                this.form = Object.assign(this.emptyForm(), row)
                this.form.timeRange = [row.startTime, row.endTime]
                if (this.form.totalQuota == null) {
                    this.form.totalQuota = undefined
                }
            } else {
                this.dialogTitle = '新增活动'
                this.form = this.emptyForm()
                this.form.schoolId = this.queryParams.schoolId
            }
            this.loadCoupons(this.form.schoolId)
            this.dialogOpen = true
        },
        resetForm() {
            this.form = this.emptyForm()
            if (this.$refs.campaignForm) {
                this.$refs.campaignForm.clearValidate()
            }
        },
        submitForm() {
            this.$refs.campaignForm.validate(async valid => {
                if (!valid) {
                    return
                }
                const payload = Object.assign({}, this.form)
                if (payload.timeRange && payload.timeRange.length === 2) {
                    payload.startTime = payload.timeRange[0]
                    payload.endTime = payload.timeRange[1]
                }
                if (payload.totalQuota === '' || payload.totalQuota === undefined || payload.totalQuota < 0) {
                    payload.totalQuota = null
                }
                delete payload.timeRange
                this.submitLoading = true
                try {
                    const res = await this.$http.post('/admin/couponCampaign/save', payload)
                    if (res.data.code === 200) {
                        this.$message.success('保存成功')
                        this.dialogOpen = false
                        this.getList()
                    } else {
                        this.$message.error(res.data.msg || '保存失败')
                    }
                } finally {
                    this.submitLoading = false
                }
            })
        },
        async changeStatus(row, status) {
            const res = await this.$http.post('/admin/couponCampaign/changeStatus', null, {
                params: { id: row.id, status }
            })
            if (res.data.code === 200) {
                this.$message.success('已更新')
                this.getList()
            } else {
                this.$message.error(res.data.msg || '更新失败')
            }
        },
        openRecords(row) {
            this.recordCampaign = row
            this.recordQuery.campaignId = row.id
            this.recordQuery.pageNum = 1
            this.recordOpen = true
            this.getRecords()
        },
        async getRecords() {
            const res = await this.$http.get('/admin/couponCampaign/records', { params: this.recordQuery })
            if (res.data.code === 200) {
                const page = res.data.data || {}
                this.recordList = page.children || []
                this.recordTotal = page.total || 0
            } else {
                this.$message.error(res.data.msg || '查询失败')
            }
        },
        handleRecordPage(page) {
            this.recordQuery.pageNum = page
            this.getRecords()
        }
    }
}
</script>
